DR.popuppolls = DR.popuppolls || {};
DR.popuppolls.struct = DR.popuppolls.struct || {};
DR.popuppolls.select = DR.popuppolls.select || {};
/** @extends {DR._Base} */
DR.popuppolls.struct.PollOption = function(par){
	/** @private */
	this._t = 1310;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.isFreeText)) this.isFreeText = Boolean(par.isFreeText);
	if(DR._Base.is(par.text)) this.text = String(par.text||'');
};
DR._Base._types[1310] = DR.popuppolls.struct.PollOption;
DR.popuppolls.struct.PollOption[__P] = new DR._Base;
DR.popuppolls.struct.PollOption[__P][__C] = DR.popuppolls.struct.PollOption;
/** @type {Number} */
DR.popuppolls.struct.PollOption.prototype.id = null;
/** @type {Boolean} */
DR.popuppolls.struct.PollOption.prototype.isFreeText = null;
/** @type {String} */
DR.popuppolls.struct.PollOption.prototype.text = null;

/** @extends {DR._Base} */
DR.popuppolls.struct.Poll = function(par){
	/** @private */
	this._t = 1311;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.body)) this.body = String(par.body||'');
	if(DR._Base.is(par.heading)) this.heading = String(par.heading||'');
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.options)){
		var tmp = [];
		for( var k in par.options ) tmp.push(DR._Base.cast(par.options [k]));
		this.options = tmp;
	}
};
DR._Base._types[1311] = DR.popuppolls.struct.Poll;
DR.popuppolls.struct.Poll[__P] = new DR._Base;
DR.popuppolls.struct.Poll[__P][__C] = DR.popuppolls.struct.Poll;
/** @type {String} */
DR.popuppolls.struct.Poll.prototype.body = null;
/** @type {String} */
DR.popuppolls.struct.Poll.prototype.heading = null;
/** @type {Number} */
DR.popuppolls.struct.Poll.prototype.id = null;
/** @type {Array.<DR.popuppolls.struct.PollOption>} */
DR.popuppolls.struct.Poll.prototype.options = null;

/** @extends {DR._Method} */
DR.popuppolls.GetPoll = function(par){
	this.select = [];
	/** @private */
	this._t = 1312;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1312] = DR.popuppolls.GetPoll;
DR.popuppolls.GetPoll[__CL] = "PopupPolls__GetPoll";
DR.popuppolls.GetPoll.TYPE_FIRST_APP = "first_app";
DR.popuppolls.GetPoll.TYPE_FIRST_WEB = "first_web";
DR.popuppolls.GetPoll.TYPE_REGULAR_APP = "regular_app";
DR.popuppolls.GetPoll[__P] = new DR._Method;
DR.popuppolls.GetPoll[__P][__C] = DR.popuppolls.GetPoll;
/** @type {Number|null} */
DR.popuppolls.GetPoll.prototype.paymentId = null;
/** @type {String} */
DR.popuppolls.GetPoll.prototype.type = null;
/** @type {DR.popuppolls.struct.Poll} */
DR.popuppolls.GetPoll.prototype.re = null;

/** @extends {DR._Method} */
DR.popuppolls.Respond = function(par){
	this.select = [];
	/** @private */
	this._t = 1313;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1313] = DR.popuppolls.Respond;
DR.popuppolls.Respond[__CL] = "PopupPolls__Respond";
DR.popuppolls.Respond[__P] = new DR._Method;
DR.popuppolls.Respond[__P][__C] = DR.popuppolls.Respond;
/** @type {Number} */
DR.popuppolls.Respond.prototype.optionId = null;
/** @type {Number} */
DR.popuppolls.Respond.prototype.pollId = null;
/** @type {String|null} */
DR.popuppolls.Respond.prototype.text = null;
/** @type {DR.roadgames.struct.Status} */
DR.popuppolls.Respond.prototype.re = null;

/** @extends {DR._Method} */
DR.popuppolls.Dismiss = function(par){
	this.select = [];
	/** @private */
	this._t = 1314;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1314] = DR.popuppolls.Dismiss;
DR.popuppolls.Dismiss[__CL] = "PopupPolls__Dismiss";
DR.popuppolls.Dismiss[__P] = new DR._Method;
DR.popuppolls.Dismiss[__P][__C] = DR.popuppolls.Dismiss;
/** @type {Number} */
DR.popuppolls.Dismiss.prototype.pollId = null;
/** @type {DR.roadgames.struct.Status} */
DR.popuppolls.Dismiss.prototype.re = null;

D.loaded();